/** @jsxRuntime classic */
/** @jsx jsx */
import { ReactNode } from 'react';
import { jsx } from '@emotion/core';
import { PieSvgProps, ResponsivePie } from '@nivo/pie';

import { style } from './DonutPieChart.style';

type Props = Omit<PieSvgProps<{ id: string; label: ReactNode; color: string; value: number }>, 'width' | 'height'> & {
  centerLabel?: React.ReactNode;
  height?: string;
};

/* Docs: https://nivo.rocks/pie */
export const DonutPieChart = (props: Props) => {
  const { centerLabel, height, ...restProps } = props;

  return (
    <div css={style.container(props)}>
      {centerLabel && <div css={style.centerLabel}>{centerLabel}</div>}
      <ResponsivePie
        startAngle={140}
        endAngle={-140}
        innerRadius={0.9}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        colors={(data) => data.data.color}
        animate={false}
        {...restProps}
      />
    </div>
  );
};
